import { format } from 'date-fns';
import { expandActivityOccurrences } from './activityUtils';
import { getParentForDate } from './custodyUtils';

const resolveParent = (explicitId, date, custodyMap, parentIds) => {
  if (explicitId === 'self') return null;
  if (explicitId) return explicitId;
  const entry = getParentForDate(custodyMap, date);
  if (!entry?.parentIndex) return null;
  return parentIds[entry.parentIndex - 1] || null;
};

export const computeUserLogistics = ({
  activities,
  custodyMap,
  parentIds,
  userId,
  rangeStart,
  rangeEnd,
}) => {
  if (!activities?.length || !userId || !parentIds?.length) return [];

  const entries = [];

  for (const activity of activities) {
    if (activity.isActive === false) continue;
    const occurrences = expandActivityOccurrences(activity, rangeStart, rangeEnd);

    for (const occ of occurrences) {
      const override = occ.instanceOverride || {};
      const dropoffId =
        override.dropoffParentId !== undefined
          ? override.dropoffParentId
          : activity.dropoffParentId;
      const pickupId =
        override.pickupParentId !== undefined
          ? override.pickupParentId
          : activity.pickupParentId;
      const startTime =
        override.startTime !== undefined ? override.startTime : activity.startTime;
      const endTime =
        override.endTime !== undefined ? override.endTime : activity.endTime;
      const time = startTime || activity.time || null;
      const location =
        override.location !== undefined ? override.location : activity.location;

      const resolvedDropoff = resolveParent(dropoffId, occ.date, custodyMap, parentIds);
      const resolvedPickup = resolveParent(pickupId, occ.date, custodyMap, parentIds);

      const userDropoff = resolvedDropoff === userId;
      const userPickup = resolvedPickup === userId;
      if (!userDropoff && !userPickup) continue;

      const role = userDropoff && userPickup ? 'both' : userDropoff ? 'dropoff' : 'pickup';

      entries.push({
        date: occ.date,
        startTime: startTime || null,
        endTime: endTime || null,
        time,
        activityId: activity.id,
        activityName: activity.name,
        color: activity.color || '#22c55e',
        location: location || null,
        childIds: activity.childIds || [],
        role,
      });
    }
  }

  entries.sort((a, b) => {
    if (a.date !== b.date) return a.date < b.date ? -1 : 1;
    const at = a.time || '99:99';
    const bt = b.time || '99:99';
    return at < bt ? -1 : at > bt ? 1 : 0;
  });

  return entries;
};

export const groupLogisticsByDate = (entries) => {
  const map = new Map();
  for (const entry of entries) {
    if (!map.has(entry.date)) map.set(entry.date, []);
    map.get(entry.date).push(entry);
  }
  return Array.from(map.entries()).map(([date, items]) => ({ date, items }));
};

export const formatLogisticsDateHeader = (dateStr, today) => {
  const todayStr = format(today, 'yyyy-MM-dd');
  if (dateStr === todayStr) return 'Today';
  const d = new Date(dateStr + 'T00:00:00');
  return format(d, 'EEEE, MMM d');
};
